import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	respondersSubTitleHeading: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.responders-sub-title-heading',
		defaultMessage: 'Responders',
		description:
			'The subtitle heading for the Responders section of the incident management settings info card.',
	},
	respondersSubTitleBody: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.responders-sub-title-body',
		defaultMessage: 'Allow multiple responder teams and individuals to be added to an incident.',
		description:
			'The body text for the Responders section of the incident management settings info card.',
	},
	respondersSubTitleLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.responders-sub-title-learn-more-link',
		defaultMessage: 'Learn how to add responders field to your service project.',
		description:
			'The learn more text for Responders section of the incident management settings info card.',
	},
	createRespondersFieldFlagTitle: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.create-responders-field-flag-title',
		defaultMessage: 'Add the responders field to your site',
		description: 'Title of the warning flag when the responders field does not exist on a project.',
	},
	createRespondersFieldFlagDescription: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.create-responders-field-flag-description',
		defaultMessage:
			'To use incident responders, first add the responders field to your Jira Service Management site.',
		description:
			'Description for the missing responders field flag, explains that they need to press the action button to create the field.',
	},
	createRespondersFieldFlagButton: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.create-responders-field-flag-button',
		defaultMessage: 'Automatically add field',
		description: 'Action button to create the responders field for a project when it is missing',
	},
	createRespondersFieldSuccessFlagTitle: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.create-responders-field-success-flag-title',
		defaultMessage: 'Responders field added to site',
		description:
			'Title for the flag that appears after the responders field is added to a project.',
	},
	createRespondersFieldSuccessFlagDescription: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.create-responders-field-success-flag-description',
		defaultMessage: 'You can now add the field to your incident.',
		description:
			'Description for the flag that appears after the responders field is added to a project.',
	},
	createRespondersFieldSuccessAlertEnabledLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.create-responders-field-success-alert-enabled-learn-more-link',
		defaultMessage: 'Learn how to add responders.',
		description:
			'Action link to learn more about adding responders field to their service project.',
	},
	createRespondersFieldErrorFlagTitle: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.create-responders-field-error-flag-title',
		defaultMessage: "We couldn't create the responders field",
		description:
			'Title for the flag that appears after the server unsuccessfully tried to add the responders field to a project.',
	},
	createRespondersFieldErrorFlagDescription: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.responders-field.create-responders-field-error-flag-description',
		defaultMessage: 'Wait a moment, then refresh the page to try again.',
		description:
			'Description for the flag that appears after the server unsuccessfully tried to add the responders field to a project.',
	},
});
